// Reserves  form config

export const reserveFields = [
  {
    key: 'reserve-information',
    name: 'Reserve Information',
    fields: [
      {
        name: 'notification_date_reserve',
        label: 'Notification Date Reserve',
        type: 'date',
        validation: {}
      },
      {
        name: 'total_days_in_hire',
        label: 'Total Days In Hire',
        type: 'integer',
        validation: {}
      },
      {
        name: 'expected_rate',
        label: 'Expected Rate (Based on GTA Grouping Applicable)',
        type: 'float',
        validation: {}
      },
      {
        name: 'current_live_hire_reserve',
        label: 'Current Live Hire Reserve',
        type: 'float',
        validation: {}
      },
      {
        name: 'total_hire_reserved',
        label: 'Total Hire Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'total_hire_reserved_vat',
        label: 'Total Hire  Reserved VAT',
        type: 'float',
        validation: {}
      },
      {
        name: 'abi_admin_reserved',
        label: 'ABI Admin Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'abi_admin_reserved_vat',
        label: 'ABI Admin Reserved VAT',
        type: 'float',
        validation: {}
      },
      {
        name: 'repair_reserved_total_no_vat',
        label: 'Repair Reserved Total (exc VAT)',
        type: 'float',
        validation: {}
      },
      {
        name: 'repair_reserved_total_vat',
        label: 'Repair Reserved Total VAT',
        type: 'float',
        validation: {}
      },
      {
        name: 'labour_hours_reserved',
        label: 'Labour Hours Reserved',
        type: 'integer',
        validation: {}
      },
      {
        name: 'labour_rate_per_hour_no_vat_reserved',
        label: 'Labour Rate Per Hour (exc VAT) Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'labour_rate_per_hour_vat_reserved',
        label: 'Labour Rate Per Hour VAT Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'labour_total_no_vat_reserved',
        label: 'Labour Total (exc VAT) Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'labour_total_vat_reserved',
        label: 'Labour Total VAT Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'parts_total_no_vat_reserved',
        label: 'Parts Total (Exc VAT) Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'parts_vat_reserved',
        label: 'Parts VAT Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'paint_materials_total_no_vat_reserved',
        label: 'Paint & Materials Total (Exc VAT) Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'paint_materials_vat_reserved',
        label: 'Paints & Materials VAT Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'specialist_total_no_vat_reserved',
        label: 'Specialist Total (Exc VAT) Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'specialist_vat_reserved',
        label: 'Specialist VAT Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'engineers_fee_reserved',
        label: 'Engineers Fee Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'engineers_fee_reserved_vat',
        label: 'Engineers Fee Reserved VAT',
        type: 'float',
        validation: {}
      },
      {
        name: 'repair_abi_admin_reserved',
        label: 'Repair ABI Admin Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'repair_abi_admin_reserved_vat',
        label: 'Repair ABI Admin Reserved VAT',
        type: 'float',
        validation: {}
      },
      {
        name: 'storage_reserved',
        label: 'Storage Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'storage_reserved_vat',
        label: 'Storage Reserved VAT',
        type: 'float',
        validation: {}
      },
      {
        name: 'recovery_reserved',
        label: 'Recovery Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'recovery_reserved_vat',
        label: 'Recovery Reserved VAT',
        type: 'float',
        validation: {}
      },
      {
        name: 'dimunition_reserved',
        label: 'Diminution Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'dimunition_reserved_vat',
        label: 'Diminution Reserved VAT',
        type: 'float',
        validation: {}
      },
      {
        name: 'other_reserved',
        label: 'Other Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'other_reserved_vat',
        label: 'Other Reserved VAT',
        type: 'float',
        validation: {}
      },
      {
        name: 'total_reserved',
        label: 'Total Reserved',
        type: 'float',
        validation: {}
      },
      {
        name: 'total_reserved_vat',
        label: 'Total Reserved VAT',
        type: 'float',
        validation: {}
      },
      {
        name: 'grand_total_reserved',
        label: 'Grand Total Reserved',
        type: 'float',
        validation: {}
      }
    ]
  }
];
